<template>

  <div class="support">

    <h1>お問い合わせ</h1>

    <div class="support_email_section">
      <p class="support_email">Email: sales@ikude.jp</p>
    </div>
    <div class="support_phone_section">
      <p class="support_phone">電話番号: 03-6721-0074</p>
    </div>








  </div>

</template>

<script>
  import {db, fb} from '../firebase'
  import moment from 'moment'

  export default {

    name: "Support",

    mounted () {
      console.log('mounted')

    },


    updated () {

    },


    data () {
      return {

      }
    },

    props: {


    },

    computed: {


    },

    methods: {


    }


  }
</script>

<style scoped>

  .support {
    text-align: left;
    margin-left: 7%;
  }

  .support h1{
    color: #5C5C5C;
    font-size: 33px;
    font-weight: normal;
    margin-top: 40px;
  }

  .support_email {
    color: #5C5C5C;
    font-size: 25px;
    font-weight: normal;
    margin: 40px 0 0 0;
    padding: 0;
  }

  .support_phone {
    color: #5C5C5C;
    font-size: 25px;
    font-weight: normal;
    margin: 10px 0 0 0;
    padding: 0;
  }



  @media(max-width: 400px){

    .support {
      text-align: left;
      margin-left: 7%;
    }

    .support h1{
      color: #5C5C5C;
      font-size: 26px;
      font-weight: bold;
      margin-top: 40px;
    }

    .support_email {
      color: #5C5C5C;
      font-size: 18px;
      font-weight: normal;
      margin: 40px 0 0 0;
      padding: 0;
    }

    .support_phone {
      color: #5C5C5C;
      font-size: 18px;
      font-weight: normal;
      margin: 6px 0 0 0;
      padding: 0;
    }

  }





</style>



// WEBPACK FOOTER //
// src/pages/Support.vue